export default __webpack_public_path__ + "static/media/cash-on-delivery.d6488097.png";